import React from 'react'

export default function WardReportDetails() {
  return <div>details</div>;
}
